import { createSlice } from "@reduxjs/toolkit"
import { IProfilesWheel, WheelEntity } from "../../entities/wheelGame"
import { getWheelPrizeList, getWheelProfileList } from "./thunks"
import { ResponseMetaData } from "../../entities/global";

interface WheelTableState {
  loading: boolean,
  prizes: WheelEntity[],
  noPrizes: boolean,
  profiles: IProfilesWheel[],
  noProfiles: boolean,
  metaEntities: ResponseMetaData;
  metaProfiles: ResponseMetaData;
}

const initialState: WheelTableState = {
  loading: false,
  prizes: [],
  noPrizes: false,
  profiles: [],
  noProfiles: false,

  metaEntities: {
    limit: 250,
    page: 1,
    pages: 1,
    total: 0,
  },
  metaProfiles: {
    limit: 250,
    page: 1,
    pages: 1,
    total: 0,
  }
}

export const wheelTableSlice = createSlice({
  name: "wheel_Table",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // getWheelPrizeList
    builder.addCase(getWheelPrizeList.pending, (state) => {
      state.loading = true;
      state.noPrizes = false;
    })
    builder.addCase(getWheelPrizeList.fulfilled, (state, action) => {
      state.loading = false;
      if (action.payload.data.length === 0) {
        state.noPrizes = true;
        state.prizes = [];
      } else {
        const { data, ...meta } = action.payload;
        state.metaEntities = meta;
        state.prizes = data.sort((a, b) => a.id - b.id);
        state.noPrizes = false;
      }
    })
    // getWheelProfileList
    builder.addCase(getWheelProfileList.pending, (state) => {
      state.loading = true;
      state.noProfiles = false
    })
    builder.addCase(getWheelProfileList.fulfilled, (state, action) => {
      if (action.payload.data.length === 0) {
        state.noProfiles = true;
        state.profiles = [];
      } else {
        const { data, ...meta } = action.payload;
        state.metaProfiles = meta;
        state.profiles = data.sort((a, b) => a.id - b.id);
        state.noProfiles = false;
      }
      state.loading = false;
    })
  },
})

export default wheelTableSlice.reducer;